import { isTransportConnectionErrorMessage } from "./transportError";

/**
 * Effect's `Cause.squash` renders a fiber interrupt with no `Die` and no
 * `Fail` (a scope tearing down for a reason other than an explicit
 * `reconnect()`) as exactly this generic message, with nothing else in the
 * cause. A live subscription's stream fiber can hit it, and the failure is
 * retry housekeeping, not an application error.
 *
 * Deliberately NOT folded into `TRANSPORT_ERROR_PATTERNS` (transportError.ts):
 * that shared allowlist also feeds Sentry's `beforeSend` filter and
 * thread-facing error copy, both of which need to keep reporting this exact
 * message for origins other than a subscription's own stream (see
 * `hasInterruptedWsTransportRequest` in sentry.tsx for the analogous,
 * narrowly-scoped carve-out already used for interrupted unary requests).
 * FOR-36709.
 */
const BARE_FIBER_INTERRUPT_MESSAGE = /^all fibers interrupted without error$/i;

/** Whether a subscription's stream failure should be retried transparently. */
export function isRetryableSubscriptionError(message: string): boolean {
  return (
    isTransportConnectionErrorMessage(message) || BARE_FIBER_INTERRUPT_MESSAGE.test(message.trim())
  );
}
